export enum InvoiceStatus {
  Pending = 'Pending',
  Failed = 'Failed',
  Reconciled = 'Reconciled',
  Accepted = 'Accepted'
}